// Central site configuration. Change SITE_URL in one place to update every
// canonical URL, Open Graph tag and JSON-LD structured-data block.
export const SITE_URL = "https://www.voiceoverkids.nl";
